// material-ui
import {Theme, TypographyVariantsOptions} from '@mui/material/styles';

// types
import {FontFamily, ThemeMode} from "types/ConfigType";

// ==============================|| DEFAULT THEME - TYPOGRAPHY  ||============================== //

const Typography = (mode: ThemeMode, fontFamily: FontFamily, theme: Theme): TypographyVariantsOptions => ({
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
        fontWeight: 600,
        // fontSize: '2.375rem',
        // lineHeight: 1.21,
        [theme.breakpoints.only("xs")]: {
            fontSize: '1.75rem',
            lineHeight: 1.25
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: '2rem',
            lineHeight: 1.25
        },
        [theme.breakpoints.only("md")]: {
            fontSize: '2.125rem',
            lineHeight: 1.29
        },
        [theme.breakpoints.only("lg")]: {
            fontSize: '2.25rem',
            lineHeight: 1.3
        },
        [theme.breakpoints.only("xl")]: {
            fontSize: '2.375rem',
            lineHeight: 1.33
        }
    },
    h2: {
        fontWeight: 600,
        // fontSize: '1.875rem',
        // lineHeight: 1.27,
        [theme.breakpoints.only("xs")]: {
            fontSize: '1.25rem',
            lineHeight: 1.29
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: '1.75rem',
            lineHeight: 1.31
        },
        [theme.breakpoints.only("md")]: {
            fontSize: '1.625rem',
            lineHeight: 1.35
        },
        [theme.breakpoints.only("lg")]: {
            fontSize: '1.725rem',
            lineHeight: 1.39
        },
        [theme.breakpoints.only("xl")]: {
            fontSize: '1.75rem',
            lineHeight: 1.41
        }
    },
    h3: {
        fontWeight: 600,
        // fontSize: '1.5rem',
        // lineHeight: 1.33,
        [theme.breakpoints.only("xs")]: {
            fontSize: '1.3rem',
            lineHeight: 1.29
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: '1.35rem',
            lineHeight: 1.30
        },
        [theme.breakpoints.only("md")]: {
            fontSize: '1.45rem',
            lineHeight: 1.31
        },
        [theme.breakpoints.only("lg")]: {
            fontSize: '1.47rem',
            lineHeight: 1.32
        },
        [theme.breakpoints.only("xl")]: {
            fontSize: '1.5rem',
            lineHeight: 1.33
        }
    },
    h4: {
        fontWeight: 600,
        // fontSize: '1.25rem',
        // lineHeight: 1.4,
        [theme.breakpoints.only("xs")]: {
            fontSize: '1.3rem',
            lineHeight: 1.29
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: '1.35rem',
            lineHeight: 1.30
        },
        [theme.breakpoints.only("md")]: {
            fontSize: '1.2rem',
            lineHeight: 1.33
        },
        [theme.breakpoints.only("lg")]: {
            fontSize: '1.23rem',
            lineHeight: 1.35
        },
        [theme.breakpoints.only("xl")]: {
            fontSize: '1.25rem',
            lineHeight: 1.4
        }
    },
    h5: {
        fontWeight: 600,
        // fontSize: '1rem',
        // lineHeight: 1.5,
        [theme.breakpoints.only("xs")]: {
            fontSize: '1rem',
            lineHeight: 1.29
        },
        [theme.breakpoints.only("sm")]: {
            fontSize: '1.025rem',
            lineHeight: 1.30
        },
        [theme.breakpoints.only("md")]: {
            fontSize: '1.05rem',
            lineHeight: 1.4
        },
        [theme.breakpoints.only("lg")]: {
            fontSize: '1.075rem',
            lineHeight: 1.45
        },
        [theme.breakpoints.only("xl")]: {
            fontSize: '1.085rem',
            lineHeight: 1.5
        }
    },
    h6: {
        fontWeight: 600,
        fontSize: '0.8rem',
        lineHeight: 1.5
    },
    caption: {
        fontWeight: 400,
        fontSize: '0.75rem',
        lineHeight: 1.5
    },
    body1: {
        fontSize: '0.875rem',
        lineHeight: 1.57
    },
    body2: {
        fontSize: '0.75rem',
        lineHeight: 1.66
    },
    subtitle1: {
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: 1.57
    },
    subtitle2: {
        fontSize: '0.75rem',
        fontWeight: 500,
        lineHeight: 1.66
    },
    overline: {
        lineHeight: 1.66
    },
    button: {
        textTransform: 'capitalize'
    }
});

export default Typography;
